/**
 * @module constants
 */

export default {
  DIALOG_BACKGROUND: '#F0EFF0'
};



// WEBPACK FOOTER //
// ./app/constants/colors.js